<template>

	<div class="container-fluid e-main">
		<slot></slot>
	</div>

</template>

<script>
	export default {
		name: 'ErcoMainOrganism',
	};
</script>


<style lang="scss">
	.e-main {
		padding: 0 !important;
		margin: 0 !important;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// ErcoMain.vue?095174be